import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '@/api/client';
import { Button } from '@/components/kit/Button';
import { Form, TextField } from '@/components/kit/Field';
import { Note } from '@/components/kit/Note';
import { useToast } from '@/components/kit/Toast';

/** Новый пароль по ссылке из письма. Токен одноразовый и живёт час. */
export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();

  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setError(null);
    try {
      await api.post('/auth/password/reset', { token, password });
      toast.show('Пароль изменён — войдите с новым');
      navigate('/');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Не удалось сменить пароль.');
    }
  };

  return (
    <div className="ui" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <div style={{ width: 'min(360px, 100% - 32px)' }}>
        <h1 className="h1" style={{ marginBottom: 'var(--s5)' }}>
          Новый пароль
        </h1>

        {token ? (
          <Form>
            <TextField
              label="Пароль"
              type="password"
              autoComplete="new-password"
              value={password}
              onValue={setPassword}
              error={error}
              onKeyDown={(e) => e.key === 'Enter' && submit()}
            />
            <Button tone="primary" onClick={submit} disabled={password.length < 8}>
              Сохранить
            </Button>
          </Form>
        ) : (
          <Note tone="warn">Ссылка неполная. Запросите восстановление заново.</Note>
        )}
      </div>
    </div>
  );
}
